"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = majorScale;

/**
 * Helper function to conform to 8 (px) major scale.
 * @param {number} x — unitless number
 * @return {number} - unitless number
 * @example
 * majorScale(2) => 2*8 = 16
 * majorScale(4) => 4*8 = 32
 */
function majorScale(x) {
  if (!Number.isInteger(x)) {
    throw new TypeError("majorScale only accepts integers as input, instead ".concat(x, " was passed."));
  }

  return x * 8;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zY2FsZXMvc3JjL21ham9yU2NhbGUuanMiXSwibmFtZXMiOlsibWFqb3JTY2FsZSIsIngiLCJOdW1iZXIiLCJpc0ludGVnZXIiLCJUeXBlRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7QUFRZSxTQUFTQSxVQUFULENBQW9CQyxDQUFwQixFQUF1QjtBQUNwQyxNQUFJLENBQUNDLE1BQU0sQ0FBQ0MsU0FBUCxDQUFpQkYsQ0FBakIsQ0FBTCxFQUEwQjtBQUN4QixVQUFNLElBQUlHLFNBQUosOERBQ2tESCxDQURsRCxrQkFBTjtBQUdEOztBQUVELFNBQU9BLENBQUMsR0FBRyxDQUFYO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEhlbHBlciBmdW5jdGlvbiB0byBjb25mb3JtIHRvIDggKHB4KSBtYWpvciBzY2FsZS5cbiAqIEBwYXJhbSB7bnVtYmVyfSB4IOKAlCB1bml0bGVzcyBudW1iZXJcbiAqIEByZXR1cm4ge251bWJlcn0gLSB1bml0bGVzcyBudW1iZXJcbiAqIEBleGFtcGxlXG4gKiBtYWpvclNjYWxlKDIpID0+IDIqOCA9IDE2XG4gKiBtYWpvclNjYWxlKDQpID0+IDQqOCA9IDMyXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG1ham9yU2NhbGUoeCkge1xuICBpZiAoIU51bWJlci5pc0ludGVnZXIoeCkpIHtcbiAgICB0aHJvdyBuZXcgVHlwZUVycm9yKFxuICAgICAgYG1ham9yU2NhbGUgb25seSBhY2NlcHRzIGludGVnZXJzIGFzIGlucHV0LCBpbnN0ZWFkICR7eH0gd2FzIHBhc3NlZC5gXG4gICAgKVxuICB9XG5cbiAgcmV0dXJuIHggKiA4XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/scales/src/majorScale.js
// module id = 180
// module chunks = 0